export const createLatestRequestTracker = () => {
  let latestRequestId = 0;
  const pendingRequestIds = new Set();
  const timeoutIds = new Set();
  const settle = requestId => {
    const wasPending = pendingRequestIds.delete(requestId);
    return {
      isLatest: requestId === latestRequestId,
      pendingCount: pendingRequestIds.size,
      wasPending
    };
  };
  const clearTimeouts = () => {
    timeoutIds.forEach(timeoutId => clearTimeout(timeoutId));
    timeoutIds.clear();
  };

  return {
    start() {
      pendingRequestIds.clear();
      clearTimeouts();
      const requestId = ++latestRequestId;
      pendingRequestIds.add(requestId);
      return requestId;
    },
    registerTimeout(timeoutId) {
      if (timeoutId != null) timeoutIds.add(timeoutId);
      return timeoutId;
    },
    unregisterTimeout(timeoutId) {
      timeoutIds.delete(timeoutId);
    },
    clearTimeouts,
    invalidate() {
      // Anything still pending here is superseded and may never call back (FastSimon
      // sometimes drops a request silently); clear it now instead of waiting on its timeout.
      pendingRequestIds.clear();
      clearTimeouts();
      return ++latestRequestId;
    },
    handleCallback(requestId, { complete = true } = {}) {
      // FastSimon may invoke one request callback more than once (for example,
      // products first and refreshed facets second). Facets-only phases stay
      // pending so pagination cannot supersede a still-awaited products phase.
      // Stale incomplete callbacks settle: a superseded facets-only id must not
      // remain pending after a newer start().
      if (!complete && requestId === latestRequestId) {
        return {
          isLatest: true,
          pendingCount: pendingRequestIds.size,
          wasPending: pendingRequestIds.has(requestId)
        };
      }
      return settle(requestId);
    },
    handleTimeout(requestId) {
      return settle(requestId);
    },
    isLatest(requestId) {
      return requestId === latestRequestId;
    },
    get pendingCount() {
      return pendingRequestIds.size;
    }
  };
};
